import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ShieldX, LogOut, Mail, AlertTriangle } from 'lucide-react';

const RestaurantSuspended = () => {
  const { logout, restaurantProfile, currentUser } = useAuth();
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      await logout();
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      navigate('/login', { replace: true });
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-surface-base via-surface-app to-surface-3 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Icono y encabezado */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-red-50 dark:bg-red-900/30 border border-red-500/30 mb-6">
            <ShieldX size={40} className="text-red-700 dark:text-red-400" />
          </div>
          <h1 className="text-3xl font-bold text-content-primary mb-3">
            Cuenta Suspendida
          </h1>
          <p className="text-content-muted text-base leading-relaxed">
            El acceso al dashboard de{' '}
            <span className="text-content-primary font-medium">
              {restaurantProfile?.name || 'este restaurante'}
            </span>{' '}
            ha sido suspendido temporalmente por el equipo de KumIA.
          </p>
        </div>

        {/* Caja de información */}
        <div className="bg-surface-3/50 border border-line-strong/50 rounded-2xl p-6 mb-6 space-y-4">
          <div className="flex items-start gap-3">
            <AlertTriangle size={20} className="text-yellow-700 dark:text-yellow-400 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-content-primary mb-1">¿Por qué estoy viendo esto?</p>
              <p className="text-sm text-content-muted">
                Tu cuenta ha sido suspendida por un administrador de la plataforma. Esto puede deberse a una revisión de cumplimiento, falta de pago u otra razón operativa.
              </p>
            </div>
          </div>

          <div className="border-t border-line-strong/50" />

          <div className="flex items-start gap-3">
            <Mail size={20} className="text-kumia-green flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-content-primary mb-1">¿Cómo resolverlo?</p>
              <p className="text-sm text-content-muted">
                Comunícate con el soporte de KumIA a través de{' '}
                <a
                  href="mailto:soporte@kumia.net"
                  className="text-kumia-green hover:underline font-medium"
                >
                  soporte@kumia.net
                </a>{' '}
                indicando el nombre de tu restaurante y tu email de cuenta.
              </p>
            </div>
          </div>
        </div>

        {/* Info de usuario */}
        {currentUser?.email && (
          <p className="text-center text-xs text-gray-600 mb-6">
            Conectado como: {currentUser.email}
          </p>
        )}

        {/* Botón de logout */}
        <button
          onClick={handleLogout}
          disabled={isLoggingOut}
          className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-surface-5/50 hover:bg-surface-5 border border-line-active/50 text-content-primary font-medium rounded-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoggingOut ? (
            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          ) : (
            <LogOut size={18} />
          )}
          {isLoggingOut ? 'Cerrando sesión...' : 'Cerrar Sesión'}
        </button>

        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mt-8">
          <img
            src={`${process.env.PUBLIC_URL || ''}/assets/kumia-logo.webp`}
            alt="KumIA"
            className="w-6 h-6"
            style={{ filter: 'drop-shadow(0 0 6px rgba(122, 201, 67, 0.4))' }}
          />
          <span className="text-sm text-content-subtle">
            <span className="text-content-primary font-medium">Kum</span>
            <span className="text-kumia-green font-medium">IA</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default RestaurantSuspended;
